import { diResolve, diInject } from "stores/diContext";
import exceptionless = require("exceptionless");
import { AppStore } from "stores/app";
import { guid } from "utils/id";


const client = new exceptionless.ExceptionlessClient({
    apiKey: "O0NHJY1RQJ47Nyu8sU3HWosxRP72WynapXzt1j6w",
    serverUrl: "https://dev-exception.sparxo.com",
    submissionBatchSize: 100,
});
const start_url = location.href;


class LoggerStore {

    @diInject() app: AppStore;

    exception(error,data?) {
        var exception = client.createException(error)
            .setReferenceId(guid())
            .setUserIdentity(this.app.userId, this.app.FullName)
            .markAsCritical(true);
        var temp = data;
        if (Object.prototype.toString.call(data) == "[object String]") {
            temp = { info: data }
        }
        var additionalData = {
            browser: `${navigator.appName}-${navigator.appCodeName}-${navigator.appVersion}`,
            platform: navigator.platform,
            lang: `${(navigator['languages'] || [navigator.language]).join(',')}(${navigator.language})`,
            ...temp
        }
        for (var prop in additionalData) {
            exception.setProperty(prop, additionalData[prop]);
        }
        exception.submit();
    }

    logWithAdditional(unique, message, data, level) {
        var eventBuilder= client.createLog('[' + unique + ']', message, level)
            .setReferenceId(guid())
            .setUserIdentity(this.app.userId, this.app.FullName);
        var temp = data;
        if (Object.prototype.toString.call(data) == "[object String]") {
            temp = { info: data }
        }
        var additionalData = {
            browser: `${navigator.appName}-${navigator.appCodeName}-${navigator.appVersion}`,
            platform: navigator.platform,
            lang: `${(navigator['languages'] || [navigator.language]).join(',')}(${navigator.language})`,
            ...temp
        }
        for (var prop in additionalData) {
            eventBuilder.setProperty(prop, additionalData[prop]);
        }
        eventBuilder.submit();
    }

    log(message, level = "INFO") {
        this.logWithAdditional("LOG", message, {}, level);
    }
    logError(message) {
        this.log(message, "ERROR");
    }
    logNotFound(url) {
        client.submitNotFound(url);
    }
}
const _logger = new LoggerStore();

if (!__TEST__) {
    window.onerror = _logger.exception.bind(_logger);
    const $: JQueryStatic = window["jQuery"] || diResolve("$");
    $(document).ajaxError(function (event, req, set, thrownError) {
        if (req.statusText === 'abort') {
            return;
        }
        var unique = "Ajax";
        if (set.url.indexOf("/oauth2/access_token") > -1) {
            var sp = (set.data as string).split('&');
            for (var s of sp) {
                if (s.indexOf('username') > -1) {
                    unique = "login_fail";
                }
            }
        }
        if (set.url.indexOf("order_and_pay") > -1) {
            //if (set.data && set.data.order) {
            //    user_name = set.data.order.customer_email_address;
            //}
            unique = "pay_fail";
        }

        _logger.logWithAdditional(unique, "Ajax Error->[" + set.type + "][" + set.url + "]" + req.responseText, {
            url: set.url,
            method: set.method,
            response: req['response'],
            result: event.result,
            startUrl: start_url,
            statusText: req.statusText,
            thrownError: thrownError,
          
        }, "Error")
    });
}

export const logger = _logger;


// WEBPACK FOOTER //
// ./src/stores/logger.ts